(async function initCouponCheck() {
	const EXTENSIONS = {
		"TopCashback": {
			"id": "lkmpdpkkkeeoiodlnmlichcmfmdjbjic",
			"name": "TopCashback",
			"files": [
				"content/styles.css"
			],
			"versions": [
				"",
				"6.6.1.0"
			]
		},
		"Molly": {
			"id": "jcbjknkcpodniflhegplcmjonnfhnhmi",
			"name": "Molly",
			"files": [
				"content/content.js",
				"content/styles.css",
				"content/favicon.ico",
				"content/index.html",
				"content/main.js",
				"content/runtime.js",
				"content/polyfills.js",
				"content/icomoon.eot",
				"content/icomoon.svg"
			],
			"versions": [
				"",
				"1.12.4_0"
			]
		},


		"Rabatta": {
			"id": "imoajpmchijilhegjalddomgffnfhfgj",
			"name": "Rabatta",
			"files": [
				"styles/colors.css",
				"styles/container-styles.css",
				"styles/discount-code-styles.css",
				"styles/draggable-styles.css",
				"styles/dragging-icon-styles.css",
				"styles/error-lost-context-style.css",
				"styles/header-styles.css",
				"styles/home-view-styles.css",
				"styles/icon-styles.css",
				"styles/offer-price-style.css",
				"styles/popup-styles.css",
				"styles/price-comparison-style.css",
				"styles/rabatta-r-styles.css",
				"styles/segmented-picker-style.css"
			],
			"versions": [
				"",
				"11.7.8"
			]
		},

		"capitaloneshopping": {
			"id": "nenlahapcbofgnanklpelkaejcehkggg",
			"name": "Capital One Shopping",
			"files": [
				"css/tailwind.css"
			],
			"versions": [
				"",
				"0.1.1266_0"
			]
		},

		"coupert": {
			"id": "mfidniedemcgceagapgdekdbmanojomk",
			"name": "Coupert",
			"files": [
				"js/elephant.js"
			],
			"versions": [
				"",
				"6.11.79_0"
			]
		},


		"BeFrugal": {
			"id": "logldmlncddmdfcjaaljjjkajcnacigc",
			"name": "BeFrugal",
			"files": [
				"AutoApplyResources/*",
				"animations/badgeIcons/*",
				"animations/checkmark/*",
				"instructionImages/*",
				"notifybar/images/*",
				"disable/*",
				"ratepopup/*",
				"fonts/*",
				"toast_icon.png",
				"search_icon.png",
				"banner_next.png",
				"banner_prev.png",
				"disableExtensionsPage.html",
				"settingsPage.html",
				"up-arrow.png",
				"chrome-arrow-small.png",
				"icon48.png",
				"icon128.png",
				"icon_cb.png",
				"logoTextIcon.png",
				"grey_icon48.png",
				"scrollbar.js",
				"scrollbar.css",
				"js/notifybar.js",
				"settings/settings.html",
				"settings/searchSites.html",
				"popup.html"
			],
			"versions": [
				"",
				"2025.6.219.0"
			]
		},

		"honey": {
			"id": "bmnlcjabgnpnenekpadlanbbkooimhnj",
			"files": [
				"checkoutPaypal/honeySPBContent.js",
				"checkoutPaypal/honeySPBResponders.js"
			],
			"versions": [
				"",
				"17.0.4_0/"
			]
		},

		"CouponBirds": {
			"id": "pnedebpjhiaidlbbhmogocmffpdolnek",
			"name": "CouponBirds",
			"files": [
				"/dist/js/inject.js"
			],
			"versions": [
				"",
				"4.2.12"
			]
		},
		"retailmenot": {
			"id": "jjfblogammkiefalfpafidabbnamoknm",
			"name": "RetailMeNot",
			"files": [
				"background.bundle.js",
				"inject.bundle.js"
			],
			"versions": [
				"",
				"4.8.0_0"
			]
		},
		"cently": {
			"id": "kegphgaihkjoophpabchkmpaknehfamb",
			"name": "Cently",
			"files": [
				"css/fonts.css",
				"siteScript.js"
			],
			"versions": [
				"",
				"7.21.0_0"
			]
		},
		"Savier": {
			"id": "lmmjippldopejmpalgcinbgmmjaikcch",
			"name": "Savier",
			"files": [
				"runtime.js",
				"main.js",
				"polyfills.js",
				"injectionvalidation.js"
			],
			"versions": [
				"",
				"1.61.0_0"
			]
		},
	}

	const COOKIE_NAME = "detected_extensions";
	const POPUP_COOKIE_NAME = "detected_extensions_popup_shown";

	const cookie = getCookie(COOKIE_NAME);
	const previouslyDetected = cookie ? safeJSONParse(decodeURIComponent(cookie)) : [];
	const hasPopupCookie = !!getCookie(POPUP_COOKIE_NAME);

	if (previouslyDetected?.length && window.Shopify?.CouponExtensionDetector?.showPopup && !hasPopupCookie) {
		for (const key of previouslyDetected) {
			try {
				if (await detectExtension(key)) {
					showPopup();
					break;
				}
			} catch { }
		}
		return;
	}

	if (cookie) {
		return;
	}

	if (document.readyState === "complete") {
		init();
	} else {
		window.addEventListener("load", init);
	}


	async function init() {
		const detected = [];

		for (const key of Object.keys(EXTENSIONS)) {
			try {
				if (await detectExtension(key)) {
					detected.push(key);
				}
			} catch { }
		}

		if (detected.length) {
			// Set cookie
			const expiryDate = new Date();
			expiryDate.setDate(expiryDate.getDate() + 7);
			setCookie(COOKIE_NAME, JSON.stringify(detected), expiryDate.toUTCString());

			// Set cart attribute if configured
			if (window.Shopify?.CouponExtensionDetector?.cartAttribute) {
				setCartAttribute(
					`__${window.Shopify.CouponExtensionDetector.cartAttribute}`,
					detected.join(", ")
				);
			}

			// Trigger show popup if configured
			if (window.Shopify?.CouponExtensionDetector?.showPopup) {
				showPopup();
			}
		} else {
			// Set empty cookie to avoid re-checking
			const expiryDate = new Date();
			expiryDate.setDate(expiryDate.getDate() + 1);
			setCookie(COOKIE_NAME, "[]", expiryDate.toUTCString());
		}
	}

	async function detectExtension(key) {
		const ext = EXTENSIONS[key];
		let found = 0;

		for (const file of ext.files) {
			for (const version of ext.versions) {
				const url = `chrome-extension://${ext.id}/${version}${file}`;
				const script = document.createElement("script");

				const loaded = await new Promise((resolve) => {
					script.src = url;
					script.onload = () => resolve(true);
					script.onerror = (error) => {
						// debugger
						resolve(false)
					};
					document.head.appendChild(script);
					setTimeout(() => {
						script.remove();
						resolve(false);
					}, 200);
				});

				if (loaded) {
					found++;
					break;
				}
			}
		}

		return found >= Math.ceil(ext.files.length / 2);
	}


	function getCookie(name) {
		return document.cookie
			.split("; ")
			.find((c) => c.startsWith(name + "="))
			?.split("=")[1];
	}

	function setCookie(name, value, dateStr) {
		document.cookie = `${name}=${value};path=/;SameSite=Lax;${dateStr ? `expires=${dateStr}` : ""}`;
	}

	function safeJSONParse(str) {
		try {
			return JSON.parse(str);
		} catch {
			return null;
		}
	}

	function showPopup() {
		setTimeout(() => {
			document.querySelector("#extension-detector-popup")?.open();
			const date = new Date();
			date.setDate(date.getDate() + 7);
			setCookie(POPUP_COOKIE_NAME, "true", date.toUTCString());
		}, (window.Shopify?.CouponExtensionDetector?.popupDelay || 0) * 1000);
	}

	async function setCartAttribute(key, value) {
		if (!key || !value) return;
		try {
			await fetch(window.Shopify.routes.root + 'cart/update.js', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ attributes: { [key]: value } })
			});
		} catch (error) {
			console.error(error);
		}
	}
})();
